import useApiCall from '@/hooks/useApiCall';
import { Divider, Typography } from '@data-products-and-ai/react-components';
import { useEffect, useState } from 'react';

import { TPartSearch, TPersonalFilters } from '../Part/types';

import { Spinner } from '@/components/Spinner';
import { CONSTANTS } from '@/constants/constants';
import {
  AreaProvider,
  TSearchParameters,
} from '@/contexts/AreaContext/AreaContext';
import React from 'react';
import { PartSearch } from './components/PartSearch';
import { PersonalFilters } from './components/PartSearch/PersonalFilters';
import { SearchResultsTable } from './components/SearchResultsTable';

/* function objectToQueryString(params: { [key: string]: any }): string {  
  const searchParams = new URLSearchParams();  
  
  for (const key in params) {  
      searchParams.append(key, params[key]);  
  }  
  
  return searchParams.toString();  
}   */

const Parts = () => {
  document.title = CONSTANTS.en.TITLE + ' - Parts';
  const { makeApiCall } = useApiCall();
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [results, setResults] = useState<TPartSearch | null>();
  const [personalFilters, setPersonalFilters] =
    useState<TSearchParameters | null>();
  const [personalFiltersEnabled, setPersonalFiltersEnabled] =
    useState<boolean>(false);
  const [personalFiltersAction, setPersonalFiltersAction] = useState<
    'PUT' | 'POST' | undefined
  >();
  const [personalFiltersId, setPersonalFiltersId] = useState<number>();

  const [searchParams, setSearchParams] = useState<string | null>(null);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleSearch = (params: any) => {
    setError('');
    setResults(null);
    setIsLoading(true);
    setSearchParams(params);
  };

  useEffect(() => {
    console.log('UseEffect');
    if (searchParams) {
      let filter = '';

      const getPersonalFilters = async () => {
        try {
          const PersonalFilters: TPersonalFilters = await makeApiCall({
            useAsFetch: true,
            method: 'GET',
            url: import.meta.env.VITE_APP_API_URL + '/personal_filters',
            headers: {
              'Content-Type': 'application/json',
            },
          });

          const urlEncodedString = Object.keys(
            PersonalFilters.personal_filters.filters,
          )
            .filter(
              (key) =>
                PersonalFilters.personal_filters.filters[
                  key as keyof TSearchParameters
                ] !== '',
            ) // Filter out empty values
            .map(
              (key) =>
                `${encodeURIComponent(key)}=${encodeURIComponent(
                  PersonalFilters.personal_filters.filters[
                    key as keyof TSearchParameters
                  ],
                )}`,
            )
            .join('&');

          console.log(urlEncodedString);
          setPersonalFiltersEnabled(
            PersonalFilters.personal_filters.is_enabled ?? false,
          );

          setPersonalFilters(PersonalFilters.personal_filters.filters);

          if (PersonalFilters.personal_filters.is_enabled) {
            filter = '?' + urlEncodedString;
            //  navigate('/parts' + filter, { replace: true });
          }
          return PersonalFilters;
        } catch (error) {
          return null;
          // Handle the error if the API call fails
        }
      };

      const getResults = async () => {
        try {
          const BOM_List = await makeApiCall({
            useAsFetch: true,
            method: 'GET',
            url: import.meta.env.VITE_APP_API_URL + '/parts' + filter,
            headers: {
              'Content-Type': 'application/json',
            },
          });
          // Process the BOM_List if the API call is successful
          setResults(BOM_List);
          setIsLoading(false);
        } catch (error) {
          // Handle the error if the API call fails
          console.log('Error fetching BOM list:', error);
          if (error instanceof Error) {
            setResults(null);
            setIsLoading(false);
            setError(error.message);
          }
        }
      };
      // if (searchParams.length <= 1) {
      //if not search params go fecth Personal Filters to see if they exist
      getPersonalFilters().then((result) => {
        console.log(result);
        if (result === null) {
          setPersonalFiltersAction('POST');
        } else {
          setPersonalFiltersAction('PUT');
          setPersonalFiltersId(result.personal_filters.id);
        }
        if (searchParams.length > 2) filter = '?' + searchParams;
        getResults();
      });
      //pu
      /* } else {
        alert(filter);
        getResults();
      } */
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  const memoizedTable = React.useMemo(() => {
    if (!results) return <></>;
    return <SearchResultsTable key="results" parts={results.parts} />;
  }, [results]);

  return (
    <div className="contentContainer">
      <div>
        <div
          style={{
            paddingLeft: 20,
            paddingRight: 20,
            paddingTop: 30,
          }}
        >
          {/*  {JSON.stringify(searchParams)} */}
          <AreaProvider>
            <PersonalFilters
              filters={personalFilters}
              personalFiltersEnabled={personalFiltersEnabled}
              setPersonalFiltersEnabled={setPersonalFiltersEnabled}
              personalFiltersId={personalFiltersId}
              setPersonalFiltersId={setPersonalFiltersId}
              action={personalFiltersAction}
            />
            <PartSearch
              onSearch={handleSearch}
              filters={personalFilters}
              filtersEnabled={personalFiltersEnabled}
            />
          </AreaProvider>
        </div>
        <Divider orientation="horizontal" padding={30} />
      </div>
      {isLoading && (
        <div
          className="contentContainer"
          style={{
            display: 'flex',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Spinner borderSize={8} size={64} color="#CCCCCC" />
        </div>
      )}
      {/* FIXME: Remove error message */}
      {error && <div>Error: {error}</div>}

      {results && (
        <>
          <div style={{ paddingLeft: 10 }}>
            <Typography tag="textsmall">
              {results.parts.length.toLocaleString('de-DE')} result
              {results.parts.length > 1 && 's'}
            </Typography>
          </div>
          {memoizedTable}
        </>
      )}
    </div>
  );
};

export default Parts;
